// extracted by css-extract-rspack-plugin
export default {"markerClickable":"a27LvAiwAeoJC1gr","markerDefault":"KEOV4U32gSI7uEy1","marker":"kSY11T1CYG4h7u9u","markerInactive":"XxSijG9RVEH8Kj43","markerActive":"wdGsCq_s_Cg1Bj7j"};